import React, {Fragment, useEffect, useState, useRef} from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {Checkbox} from "primereact/checkbox";

import {ConfirmDialogService, IamColumn, ToastService, useDataTable, useDataTableBasic, useDialogCrup, useToolbar} from '@iamsoftware/react-hooks';

import {AgreementService as Service} from './AgreementService';

import {NewAgreement} from './NewAgreement';
import {AgreementFile} from './AgreementFile';
import {TemplateDetail} from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/TemplateDetail';
import {AgreementTemplateService} from '../../quan-ly-loai-tai-lieu/tai-lieu-mau/AgreementTemplateService';
import {SignService} from '../../../service/SignService';
import { DocumentSignService } from '../../../service/DocumentSignService';
import {AppStorage} from '../../../service/UserStorage';

interface Props {
  beCreate?: boolean,
}

export const Agreements = (props: Props) => {

  const dataKey = 'agreementId';
  const header = 'Hợp đồng'
  const [displayNewAgreement, setDisplayNewAgreement] = useState(null);
  const [displayAgreementFile, setDisplayAgreementFile] = useState(null);
  const [headerResult, setHeaderResult] = useState(null);
  const [totalRecords, setTotalRecords] = useState('')
  const [displayDetail, setDisplayDetail] = useState(false)
  const [displayAgreementDetail, setDisplayAgreementDetail] = useState(null)
  const [agreementParties, setAgreementParties] = useState([])
  const [displayFile, setDisplayFile] = useState(null);
  const [pdfBase64, setPdfBase64] = useState<string>('');

  useEffect(() => {
    if (props.beCreate) {
      doCreate();
    }
  }, [props.beCreate]);

  const {render: renderDataTable, reloadLazyData} = useDataTable({
    tableHeader: headerResult,
    dataKey,
    columns: [
      {
        field: 'agreementNo', header: 'Số HĐ', width: 100, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return <span className="underline text-primary" onClick={() => doUpdate(true, rowData)} title=" Click để xem chi tiết">{rowData.agreementNo}</span>
        }
      },
      {field: 'agreementDate', header: 'Ngày HĐ', width: 100, dataType: 'date'},
      {
        field: 'templateAgtName', header: 'Mẫu HĐ', width: 220, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          if (rowData?.templateAgtName) {
            return <span className="underline text-primary" onClick={() => viewTemplate(rowData)} title=" Click để xem mẫu hợp đồng">[{rowData.templateAgtPseudoId}]- {rowData.templateAgtName}</span>
          } else {
            return <span>Không sử dụng mẫu HĐ</span>
          }
        }
      },
      {
        field: 'otherPartyNames', header: 'Đối tượng', width: 220, dataType: 'custom', customCell(rowData: any): any {
          return <div>
            {rowData?.otherPartyNames?.split(';').map(e => {
              return <li>{e}</li>
            })}
          </div>

        }
      },
      {field: 'agreementTotal', header: 'Giá trị HĐ', width: 100, matchMode: 'numeric', dataType: 'number',},
      {field: 'address1', header: 'Địa chỉ', width: 150, matchMode: 'contains', hidden: true},
      {
        field: 'textData', header: 'Ký xác thực', width: 220,dataType: 'custom', customCell(rowData: any): any {
          return <div>
            {rowData?.textData?.split(';').map(e => {
              return <li>{e}</li>
            })}
          </div>

        }
      },
      {field: 'status', header: 'Trạng thái', width: 100, matchMode: 'contains'},

    ],
    indexColumnWidth: 45,
    actionColumnWidth: 140,
    getList: lazyLoadEvent => {
      return Service.getList(lazyLoadEvent).then(result => {
        setTotalRecords(result.totalRecords)
        return result;
      });
    },
    initActions(items: Array<any>) {
      if (items) {
        items.forEach(item => {
          const badge: any = {};
          if (item.sentEmailCount) {
            badge.badge = item.sentEmailCount;
            badge.badgeClassName = 'p-badge-danger';
          }
          item.actions = [
            {icon: 'pi pi-eye', title: 'Xem pdf', className: 'p-button-info', command: () => setDisplayAgreementFile(item)},
            {icon: 'pi pi-envelope', title: 'Gửi Email', className: 'p-button-help', command: () => rowSendEmail(item), props: badge}
          ]

          if (item.statusId === 'AGT_CREATED') {
            item.actions.push({icon: 'pi pi-user-edit', title: 'Ký hợp đồng', className: 'p-button-success', command: () => signFile(item)})
            item.actionMenus = [
              {icon: 'pi pi-file', label: 'Xem chi tiết', className: 'p-button-danger', command: () => doUpdate(true, item)},
              {icon: 'pi pi-pencil', label: 'Chỉnh sửa', className: 'p-button-danger', command: () => doUpdate(false, item)},
              {icon: 'pi pi-trash', label: 'Xóa hợp đồng', className: 'p-button-secondary', command: () => rowDeleteItem(item)},
            ]
          } else if (item.statusId === 'AGT_SIGN_COMPLETED') {
            item.actionMenus = [
              {icon: 'pi pi-file', label: 'Xem chi tiết', className: 'p-button-danger', command: () => doUpdate(true, item)},
              {icon: 'pi pi-times', label: 'Hủy hợp đồng', className: 'p-button-secondary', command: () => rowCancel(item)},
            ]
          } else if (item.statusId === 'AGT_SIGNING_PROCESS') {
            item.actions.push({icon: 'pi pi-user-edit', title: 'Ký hợp đồng', className: 'p-button-success', command: () => signFile(item)})

            item.actionMenus = [
              {icon: 'pi pi-file', label: 'Xem chi tiết', className: 'p-button-danger', command: () => doUpdate(true, item)},
              {icon: 'pi pi-times', label: 'Hủy hợp đồng', className: 'p-button-secondary', command: () => rowCancel(item)},
            ]
          } else if (item.statusId === 'AGT_CANCELLED') {
            item.actionMenus = [
              {icon: 'pi pi-file', label: 'Xem chi tiết', className: 'p-button-danger', command: () => doUpdate(true, item)},
            ]
          }
        })
      }
    }
  });
  const signFile = (data) => {
    Service.unsignedParties(data?.agreementId).then(data => {
      setAgreementParties(data.agreementParties.map(field => {
        if (field.checked === "Y") {
          field.checked = true
        } else {
          field.checked = false
        }
        field.dataKey = `${field.roleTypeId}-${field.partyId}`
        return field;
      }))
    })
    setDisplayFile(Date.now());
  }
  const onEditorChange = (rowData, column, newValue) => {
    setAgreementParties(prevItems => prevItems.map(prevItem => {
      if (prevItem.dataKey === rowData.dataKey) {
        return {
          ...prevItem,
          [column.field]: newValue
        }
      }
      return prevItem;
    }));
  }
  const {render: renderEmailMessage} = useDataTableBasic({
    tableHeader: 'Đối tượng',
    dataKey: 'dataKey',
    indexColumnWidth: 45,
    columns: [
      {
        field: 'checked', header: 'Chọn', width: 120,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          field: {type: 'Checkbox'}
        }, className: 'text-center'
      },
      {
        field: 'partyName', header: 'Người nhận', minWidth: 400,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          // field: {type: 'text'}
        }
      },
      {
        field: 'emailAddress', header: 'Email', minWidth: 100,
        dataType: 'editor', editorConfig: {
          onEditorChange,
          // field: {type: 'text'}
        }
      },
      {field: 'roleType', header: 'Vai trò', minWidth: 75},
      {
        header: 'MST/CCCD/CMND', minWidth: 100, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.taxCode) {
            return rowData.taxCode
          } else {
            return rowData.identityCard
          }
        }
      },
    ],
    items: agreementParties
  });
  const validate = () => {
    return new Promise<void>((resolve, reject) => {
      agreementParties.map(it => {
        it.checked = it.checked ? 'Y' : 'N';
        return it;
      })
      if (agreementParties?.length) {
        if (agreementParties.filter(it => it.checked === 'Y' && !it.emailAddress).length) {
          reject();
          ToastService.error(`Người nhận [${agreementParties.filter(it => it.checked === 'Y' && !it.emailAddress).map(it => it.partyName).join(', ')}] chưa nhập địa chỉ email.`);
        } else {
          agreementParties.map(agreementParty => {
            agreementParty.toAddresses = agreementParty.emailAddress
          })
          resolve();
        }
      } else {
        reject();
        ToastService.error('Chưa có dữ liệu người nhận.');
      }
    });
  }
  const {render: renderDialogSentEmailNotify, update: sentEmailNotify} = useDialogCrup({
    header: '!Gửi email thông báo',
    dataKey,
    width: '100rem',
    fields: [
      {field: 'agreementId', type: 'hidden'},
      {field: 'subject', header: 'Tiêu đề', required: true, className: 'md:col-12'},
      {type: 'custom', body: renderEmailMessage()}
    ],
    updateItem: async (id, item) => {
      item.agreementParties = agreementParties.filter(it => it.checked === true)
      return validate().then(() => {
        Service.sentEmailNotifyBuyer(id, item).then(()=>{
          reloadLazyData()
        })
      })
    },
    reloadLazyData,
    submitLabel: 'Gửi'
  });

  const {render: renderDialogCancel, update: sentEmailCancel} = useDialogCrup({
    header: '!Xác nhận hủy hợp đồng',
    dataKey,
    width: '40rem',
    fields: [
      {field: 'agreementId', type: 'hidden'},
      {field: 'cancelReason', header: 'Lý do hủy', className: 'md:col-12'},
    ],
    updateItem: async (id, item) => {
      return Service.cancelAgreement(id, item);
    },
    reloadLazyData,
    submitLabel: 'Hủy'
  });
  const {render: renderSignAgreement} = useDataTableBasic({
    tableHeader: 'Đối tượng',
    dataKey: 'dataKey',
    indexColumnWidth: 45,
    columns: [
      {
        field: 'checked', header: 'Chọn', width: 120,
        dataType: 'editor', editorConfig: {
          onEditorChange(rowData: any, column: IamColumn, newValue: any) {
            setAgreementParties(prevItems => prevItems.map(prevItem => {
              if (prevItem.dataKey === rowData.dataKey) {
                return {
                  ...prevItem,
                  [column.field]: newValue
                }
              } else {
                return {
                  ...prevItem,
                  [column.field]: false
                }
              }
              return prevItem;
            }));
          },
          field: {type: 'Checkbox'}
        }, className: 'text-center'
      },
      {field: 'partyName', header: 'Tên đối tượng', minWidth: 150},
      {
        header: 'MST/CCCD/CMND', minWidth: 100, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.taxCode) {
            return rowData.taxCode
          } else {
            return rowData.identityCard
          }
        }
      },
      {field: 'roleType', header: 'Vai trò', minWidth: 75},
      {field: 'emailAddress', header: 'Email', minWidth: 75},
      {field: 'contactNumber', header: 'SĐT', minWidth: 75},

    ],
    items: agreementParties
  });
  const rowDeleteItem = (input) => {
    ConfirmDialogService.confirm('Xóa hợp đồng', `Xác nhận xóa hợp đồng này?`, () => {
      Service.delete(input.agreementId).then(() => {
        ToastService.success();
        reloadLazyData();
      });
    });
  }

  const rowSendEmail = (input) => {
    Service.unsignedParties(input?.agreementId).then(data => {
      setAgreementParties(data.agreementParties.map(field => {
        field.checked = true;
        field.dataKey = `${field.roleTypeId}-${field.partyId}`
        return field;
      }))
    })
    sentEmailNotify({'agreementId': input?.agreementId, 'subject': `Bạn có hợp đồng cần ký từ ${input.organizationPartyName}`});
  }

  const rowCancel = (input) => {
    if (input) {
      sentEmailCancel({
        ...input,
      })
    }
  }

  const doCreate = () => {
    setDisplayNewAgreement(true);
  }

  useEffect(() => {
    setHeaderResult(tabHeader)
  }, [totalRecords]);
  useEffect(() => {
    if (AppStorage.get('reload')){
      reloadLazyData()
    }
  }, [AppStorage.get('reload')]);

  const doUpdate = (doView?: boolean, rowData?: any) => {
    if (doView === true) {
      window.open(`/#/hop-dong/chi-tiet-hop-dong/${rowData?.agreementId}`);
    } else {
      Service.get(rowData?.agreementId).then(res => {
        res.doView = false
        setDisplayNewAgreement(res)
      })
    }

  }
  const onSubmit = async () => {
    const nhot = []
    agreementParties.map(agreementParty => {
      if (agreementParty.checked === true) {
        nhot.push(agreementParty)
      }
    })
    if (nhot[0].agreementId) {
      try {
        const row = nhot[0];
        const signResult = await DocumentSignService.sign({
          referenceNumber: row.agreementId,
          signingSecretCode: '', 
          restPath: '/rest/s1/iam-agreement',
          taxCode: row.pseudoId || row.customerPseudoId,
          signedBy: row.roleTypeId === 'SellerSignedExec' ? 'SELLER' : 'BUYER',
          agreementId: row.agreementId,
          partyId: row.partyId,
          roleTypeId: row.roleTypeId
        });

        if (signResult?.success && signResult?.data?.signedFilesBase64?.length > 0) {
          const signedPdfBase64 = signResult.data.signedFilesBase64[0];
          
          await Service.pushSignedData({
            signedBy: row.roleTypeId === 'SellerSignedExec' ? 'SELLER' : 'BUYER',
            base64FileData: signedPdfBase64,
            agreementId: row.agreementId,
            partyId: row.partyId,
            roleTypeId: row.roleTypeId,
            referenceNumber: null,
            signingSecretCode: ''
          });
          
          ToastService.success('Ký số thành công và đã lưu file!');
        } else {
          ToastService.error('Ký số thất bại!');
          
          // Gọi API updateSigningError khi ký thất bại (giống Java Swing)
          try {
            await Service.updateSigningError({
              agreementId: row.agreementId,
              partyId: row.partyId,
              roleTypeId: row.roleTypeId,
              referenceNumber: null,
              signingSecretCode: ''
            });
            
          } catch (apiError) {
            console.error('Error calling updateSigningError API:', apiError);
          }
        }

        setDisplayFile(null)
        setPdfBase64('')
        reloadLazyData();
      } catch (error) {
        console.error('Error fetching files from BE:', error);
        ToastService.error('Có lỗi khi lấy file từ server.');
        
        // Gọi API updateSigningError khi gặp exception (giống Java Swing)
        try {
          const row = nhot[0];
          await Service.updateSigningError({
            agreementId: row.agreementId,
            partyId: row.partyId,
            roleTypeId: row.roleTypeId,
            referenceNumber: null,
            signingSecretCode: ''
          });
          
        } catch (apiError) {
          console.error('Error calling updateSigningError API:', apiError);
        }
      }
    } else {
      ToastService.error('Chưa chọn đối tượng ký.');
    }
  }
  const viewTemplate = (rowData) => {
    AgreementTemplateService.get(rowData.templateAgreementId).then(data => {
      if (data.productCategoryId) {
        data.categories = {value: data.productCategoryId, label: `[${data.categoryPseudoId}] - ${data.categoryName}`}
      }
      setDisplayAgreementDetail(data);
    })
  }
  const tabHeader = (
    <div>
      <div className="flex align-items-center justify-content-between ">
        <Fragment>
          <span>{totalRecords} {header}</span>
          <Button label="Thêm" icon="pi pi-plus" severity="success" className="mr-4 mb-1 w-7rem h-2rem"
                  size="small" onClick={() => doCreate()}/>
        </Fragment>
      </div>
    </div>
  );
  const fileFooter = (
    <div>
      {displayFile && <div>
				<Button label="Xác nhận ký" icon="pi pi-check" className=" p-button-success p-button-sm" type="button" onClick={() => onSubmit()}/>
				<Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayFile(false)}/>
			</div>}
    </div>
  );

  return (
    <div className="grid">
      <div className="col-12" style={{maxHeight: 'calc(100vh - 6rem)'}}>
        {renderDataTable()}
      </div>

      {renderDialogSentEmailNotify()}
      {renderDialogCancel()}
      <TemplateDetail display={displayDetail} setDisplay={setDisplayDetail}/>
      <NewAgreement display={displayNewAgreement} setDisplay={setDisplayNewAgreement} reloadLazyData={reloadLazyData}/>
      <AgreementFile display={displayAgreementFile} setDisplay={setDisplayAgreementFile} reloadLazyData={reloadLazyData}/>
      <Dialog header={`Chọn đối tượng ký`} footer={fileFooter} visible={!!displayFile} style={{width: '80rem', height: '30rem',}} position="center" onHide={() => setDisplayFile(false)}>
        {renderSignAgreement()}
      </Dialog>
    </div>
  );
}